import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getBreadcrumbs(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/breadcrumbs",
    method: "post",
    data: data
  });
}